export default __webpack_public_path__ + "static/media/honeymoon.4fa7bde2.webp";